<template>

    <div class="resultado h-screen p-3 flex flex-col justify-center ">
    <!-- ==== CONTEUDO ==== -->
        <h1 class="sm:text-4xl md:text-6xl mt-0 md:mt-4 text-white font-black text-center" v-if="acertos >= 70">Parabéns {{userisloged.name}}!</h1>
        <h1 class="sm:text-4xl md:text-6xl mt-0 md:mt-4 text-white font-black text-center" v-else>Foi por pouco {{userisloged.name}}!</h1>
        <p class="mt-8 md:mt-4 text-white sm:text-lg md:text-2xl text-center">O você acertou o total de: </p>
        <h3 class="text-center nota font-black">{{acertos}}%</h3>
      <h2 class="mt-8 md:mt-0 text-white text-lg md:text-2xl font-black  text-center" v-if="acertos >= 70">Com esse resultado entendemos que você <br> pegou informação suficiente para você caminha <br> muito bem na nossa empresa</h2>
      <h2 class="mt-8 md:mt-0 text-white text-lg md:text-2xl font-black  text-center" v-else>Com esse resultado entendemos que você <br> ainda precisa da uma olhadinha nos slides <br> novamente. </h2>

        <div class="bg-white container mt-8 p-8 text-center botoes">

            <h4 class="azulwdc font-bold text-lg md:text-2xl" v-if="acertos >= 70">Nós também queremos ser avaliados!
              Poderia realizar uma pequena avaliação desse nosso processo de integração?
            </h4>
            <h4 class="azulwdc font-bold text-lg md:text-2xl" v-else>Relaxa, é só ir até os slides novamente ou realizar novamente o teste.
            Qual você escolhe?</h4>

            <div class="my-3 md:my-5 grid  text-xl" v-if="acertos >= 70">
                <button class="text-white p-2 md:p-4 bg-vermelhowdc mx-3 border-none" @click="goToAvaliacao">AVALIAR</button>
            </div>
            <div class="my-3 md:my-5 grid grid-cols-2 text-xl" v-else>
                <button class="text-white p-2 md:p-4 bg-vermelhowdc mx-3 border-none" @click="goToSlides">VER SLIDES</button>
                <button class="text-white p-2 md:p-4 bg-vermelhowdc mx-3 border-none" @click="goToTeste">TENTAR NOVAMENTE</button>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Equipe",
        props: [],
        created() {
          if (!this.userisloged){
            this.$router.push({name:'novaintegracao-login'})
          }
            if (!this.escolhas){
              this.$router.push({name:'integracao-avaliacaoinicio'})
            }
        },
        data() {
            return {
                pronome: 'a',
                animation_path: [],
                width: window.innerWidth,
                gabarito: [2,3,0,2,2,3,1,2,2,2],
            }
        },
        methods: {
            next(step) {
                this.$store.dispatch('integracao/setStep', step).then(() => {
                    this.$router.push({name: 'integracao-' + this.$store.state.integracao.page});
                })
            },
          goToSlides(){
            this.$router.push({name:'integracao-slides',params:{id:1}})
          },

          goToTeste(){
            this.$router.push({name:'integracao-avaliacao',params:{id:1}})
          },
          goToAvaliacao(){
            this.$router.push({name:'integracao-feedback'})
          },
          storeDesempenho(){
               let dados = {
                  'desempenho':this.acertos,
                 'user':this.userisloged.id
               }
            this.$store.dispatch('integracao/storeDesempenho', dados).then(() => {

            })
          }

        },
         watch: {
            windowWidth() {
                this.width = window.innerWidth;
            }
        },
        computed: {
            acertos() {
              var escolhas = JSON.parse(localStorage.getItem('integracaoEscolhas')) ;
              let acertos = 0;
              if (escolhas){
                let respostas = escolhas.respostas;
                this.gabarito.forEach((resp,index)=>{
                  console.log(respostas[index],resp)
                  if (respostas[index] == resp){
                    acertos++;
                  }
                });
              }
                return (acertos/this.gabarito.length)*100
            },
          escolhas(){
            return localStorage.getItem('integracaoEscolhas');
          },
          userisloged(){
            let user = localStorage.getItem('integracaoLogged')
            return JSON.parse(user);
          }

        },mounted() {
          this.storeDesempenho();
      }
    }
</script>

<style scoped>
.resultado{
    background-image: url('../../assets/images/novaintegracao/bg-avalicao.png') !important;
    background-size: cover;
}
.topo {
    min-height: 100px;
}
.nota{
    color: #E0A372;
    font-size: 130px;
}
.mobile{
    display: none;
  }
  @media (max-width:600px){
    .descktop{
      display: none;
    }
    .mobile{
      display: block;
    }
}

.botoes{
    max-width: 500px;
}

@media(max-width: 600px){
    .nota {
    font-size: 100px;
}
}

@media(max-width:500px){
    .botoes {
    max-width: 400px;
}
.topo {
    min-height: 110px;
}

}

@media(max-width:400px){
    .botoes {
    max-width: 320px;
    }
    .nota {
    font-size: 60px;
}

}


</style>
